<template>
    <div class="timeline-container">
        <div class="timeline">
            <!-- Línea central -->
            <div class="timeline-line"></div>
            <!-- Grupos por día -->
            <div
                v-for="(dayEvents, date) in groupedEvents"
                :key="date"
                class="day-group">
                <div class="day-header">
                    <div class="day-subtitle left" style="margin-left: -10%">
                        Diagnóstico(s)
                    </div>
                    <div class="day-title center">
                        {{ formatDate(dayEvents.date) }}
                    </div>
                    <div class="day-subtitle right" style="margin-right: -6%">
                        Receta(s)
                    </div>
                </div>
                <!-- Eventos del día -->
                <div class="events-container">
                    <v-row
                        v-for="(event, index) in dayEvents.events"
                        :key="index"
                        class="event-pair">
                        <v-divider></v-divider>
                        <!-- Lado izquierdo -->
                        <v-col
                            cols="5"
                            class="d-flex justify-center align-center">
                            <v-card
                                class="event-timeline"
                                v-if="
                                    event.appointmentDiseases &&
                                    event.status != 'cancelled'
                                "
                                :class="{
                                    'cancelled-note':
                                        event.status === 'cancelled',
                                }">
                                <v-card-title class="card-title-container">
                                    <span class="card-title"> Médico: </span>
                                    <span class="card-text">
                                        {{ event.practitioner }}
                                    </span>
                                </v-card-title>
                                <v-card-text class="card-body">
                                    <div class="tags-container">
                                        <span class="card-text">
                                            Diagnóstico:
                                        </span>
                                        <div
                                            v-for="(
                                                disease, index
                                            ) in event.appointmentDiseases"
                                            :key="index"
                                            :class="{
                                                'tag-disease':
                                                    disease.diseaseId,
                                                'tag-custom':
                                                    !disease.diseaseId,
                                            }">
                                            <span>{{
                                                disease.diseaseName
                                            }}</span>
                                        </div>
                                    </div>
                                    <span>
                                        <span class="card-text">
                                            Nota: {{ event.note }}
                                        </span>
                                    </span>
                                </v-card-text>
                                <v-card-text class="footer-card">
                                    <button
                                        class="boton-principal"
                                        @click="printExtraContent(event)"
                                        :disabled="
                                            event.status === 'cancelled'
                                        ">
                                        <v-icon class="operation-icon mr-1" left
                                            >mdi mdi-printer</v-icon
                                        >
                                        <span
                                            style="
                                                color: var(--color-principal);
                                            "
                                            class="trebuchet">
                                            Imprimir
                                        </span>
                                    </button>
                                    <button
                                        class="boton-principal"
                                        @click="crearReceta(event)"
                                        :disabled="disabledDiagnostic(event)">
                                        <v-icon class="operation-icon mr-1" left
                                            >mdi-note-text-outline</v-icon
                                        >
                                        <span class="trebuchet"> Recetar </span>
                                    </button>
                                    <button
                                        class="boton-principal"
                                        @click="editarDiagnostico(event)"
                                        :disabled="disabledDiagnostic(event)">
                                        <v-icon class="operation-icon mr-1" left
                                            >mdi-pencil-outline</v-icon
                                        >
                                        <span class="trebuchet"> Editar </span>
                                    </button>
                                    <button
                                        class="boton-principal-cancel"
                                        @click="
                                            appointmentOpenDialog(event._key)
                                        "
                                        :disabled="disabledDiagnostic(event)">
                                        <span class="trebuchet">
                                            {{
                                                event.status === 'cancelled'
                                                    ? 'Cancelada'
                                                    : 'Cancelar'
                                            }}
                                        </span>
                                    </button>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <!-- Línea conectora -->
                        <v-col
                            cols="2"
                            class="d-flex justify-center align-center">
                            <div
                                class="pair-connector"
                                v-if="
                                    event.requestedMedications &&
                                    event.appointmentDiseases
                                ">
                                <div
                                    class="icon-equal mdi mdi-arrow-right-bold"></div>
                            </div>
                        </v-col>
                        <!-- Lado derecho -->
                        <v-col
                            cols="5"
                            class="justify-center align-center"
                            style="align-content: center">
                            <div
                                v-for="(
                                    medications, index
                                ) in event.requestedMedications"
                                :key="index">
                                <v-card
                                    class="event-timeline"
                                    v-if="event.requestedMedications"
                                    :class="{
                                        'cancelled-note':
                                            event.requestedMedicationsStatus ===
                                            false,
                                    }">
                                    <v-card-title class="card-title-container">
                                        <span class="card-title">
                                            Médico:
                                        </span>
                                        <span class="card-text">
                                            {{ medications[0]?.practitioner }}
                                        </span>
                                    </v-card-title>
                                    <v-card-text class="card-body">
                                        <span class="card-title">
                                            Medicamentos recetados:
                                        </span>
                                        <ul
                                            v-for="(
                                                medication, index
                                            ) in medications"
                                            :key="index"
                                            class="medication-list">
                                            <li
                                                class="medication-item trebuchet">
                                                {{ medication.medication }}
                                            </li>
                                        </ul>
                                    </v-card-text>
                                    <v-card-text class="footer-card">
                                        <span class="date trebuchet">
                                            <!-- {{ formatDate(event.created_at) }} -->
                                        </span>
                                        <div class="operation-wrapper">
                                            <button
                                                class="boton-principal"
                                                @click="
                                                    verReceta(
                                                        index,
                                                        event.diseases,
                                                    )
                                                "
                                                :disabled="
                                                    event.requestedMedicationsStatus ==
                                                    false
                                                ">
                                                <v-icon
                                                    icon="mdi-eye-outline"
                                                    class="operation-icon mr-1" />
                                                <span
                                                    style="
                                                        color: var(
                                                            --color-principal
                                                        );
                                                    "
                                                    class="trebuchet">
                                                    Ver
                                                </span>
                                            </button>
                                            <!-- <button
                                                class="custom-button cancel-button trebuchet"
                                                :class="{
                                                    'btn-disabled':
                                                        event.requestedMedicationsStatus ===
                                                        false,
                                                    'btn-active':
                                                        event.requestedMedicationsStatus !==
                                                        false,
                                                }"
                                                @click="
                                                    prescriptionOpenDialog(
                                                        event.requestedMedicationsId,
                                                    )
                                                "
                                                :disabled="
                                                    event.requestedMedicationsStatus ==
                                                    false
                                                ">
                                                Revocar receta
                                            </button> -->
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </div>
    <v-dialog v-model="appointmentDialog" persistent>
        <v-row justify="center">
            <v-card class="h-50 min-w-25">
                <i
                    class="mdi mdi-close-circle boton-cerrar-x"
                    style="
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        float: right;
                        font-size: 25px;
                        cursor: pointer;
                        color: white;
                    "
                    @click="appointmentDialog = false"></i>
                <v-card-title> Diagnóstico </v-card-title>
                <v-card-text class="text-center trebuchet">
                    ¿Estás seguro que quieres cancelar este diagnóstico? Esta
                    accion no puede deshacerse.
                </v-card-text>
                <v-card-actions class="justify-center">
                    <button
                        class="boton-principal-cancel"
                        @click="triggerCancelAppointment()">
                        Revocar Diagnóstico
                    </button>
                </v-card-actions>
            </v-card>
        </v-row>
    </v-dialog>
    <v-dialog v-model="prescriptionDialog" persistent>
        <v-row justify="center">
            <v-card class="h-50 min-w-25">
                <i
                    class="mdi mdi-close-circle boton-cerrar-x"
                    style="float: right; font-size: 25px; cursor: pointer"
                    @click="prescriptionDialog = false"></i>
                <v-card-text class="text-center trebuchet">
                    ¿Estás seguro que quieres cancelar la receta? Esta accion no
                    puede deshacerse.
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="#6c757d" @click="prescriptionDialog = false"
                        >Cerrar</v-btn
                    >
                    <v-btn color="red" @click="triggerCancelPrescription()"
                        >Revocar receta</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-row>
    </v-dialog>
    <v-dialog v-model="prescriptionView" persistent>
        <prescriptionDialog
            v-bind="{
                patientId: patientId,
                diseases: this.patientDisease,
            }"
            :recipe-id="selectedRecipeId"
            @closeDialog="prescriptionView = false"
            @close="closeDialogPrescription"
            @click:outside="closeDialogPrescription" />
    </v-dialog>
</template>

<script>
import prescriptionDialog from '@/components/global/prescription-dialog.vue';
import { getPatientById } from '@/api/pacientes';

export default {
    components: {
        prescriptionDialog,
    },
    emits: ['cancel-appointment', 'cancel-prescription'],
    props: {
        appointments: {
            type: Array,
            required: true,
        },
        practitionerId: {
            type: String,
            required: true,
        },
        patientId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appointmentDialog: false,
            selectedAppointment: '',
            prescriptionView: false,
            selectedRecipeId: '',
            patientDisease: [],
            prescriptionDialog: false,
            selectedPrescription: '',
            itemsPatient: [],
        };
    },
    computed: {
        groupedEvents() {
            const groups = {};
            const getDateKey = (dateStr) => dateStr.substring(0, 10);
            const events = this.appointments; // Renombrado para claridad
            events.forEach((event) => {
                const dateKey = getDateKey(event.created_at);

                if (!groups[dateKey]) {
                    groups[dateKey] = {
                        date: event.created_at,
                        events: [],
                    };
                }

                groups[dateKey].events.push(event);
            });
            return groups;
        },
    },
    mounted() {
        this.fetchPatientData();
    },
    methods: {
        fetchPatientData() {
            getPatientById(this.patientId)
                .then((patient) => {
                    this.itemsPatient = patient;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        formatDate(date) {
            const appointmentsDate = new Date(date);
            return appointmentsDate.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
        appointmentOpenDialog(index) {
            this.selectedAppointment = index;
            this.appointmentDialog = true;
        },
        async triggerCancelAppointment() {
            this.$emit('cancel-appointment', this.selectedAppointment);
            this.appointmentDialog = false;
        },
        prescriptionOpenDialog(index) {
            this.selectedPrescription = index;
            this.prescriptionDialog = true;
        },
        async triggerCancelPrescription() {
            this.$emit('cancel-prescription', this.selectedPrescription);
            this.prescriptionDialog = false;
        },
        verReceta(recipeId, disease) {
            this.patientDisease = disease;
            this.showRow({ id: recipeId });
        },
        showRow(row) {
            this.selectedRecipeId = row.id;
            this.prescriptionView = true;
        },
        closeDialogPrescription() {
            this.prescriptionView = false;
        },
        printExtraContent(appointment) {
            const print_window = window.open('', '_blank');

            if (!print_window) {
                alert('Permite ventanas emergentes para generar el documento');
                return;
            }

            const formattedBirthdate = this.formatDate(
                this.itemsPatient.birthdate,
            );

            print_window.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        .header { text-align: center; margin-bottom: 30px; }
                        .section { margin-bottom: 25px; border-bottom: 1px solid #eee; padding-bottom: 15px; }
                        .section-title { font-weight: bold; color: #2c3e50; margin-bottom: 10px; font-size: 18px; }
                        .grid-container { display: grid; grid-template-columns: auto 1fr; gap: 8px 15px; }
                        .label { font-weight: bold; color: #7f8c8d; }
                        .medication, .disease-item {
                            background-color: #f8f9fa;
                            padding: 10px;
                            border-radius: 5px;
                            margin-top: 5px;
                        }
                        .status-active { color: #27ae60; font-weight: bold; }
                        .status-inactive { color: #e74c3c; }
                        .disease-link { color: #2980b9; text-decoration: none; }
                        .multi-container { display: flex; flex-direction: column; gap: 8px; }
                        .not-available { color: #95a5a6; font-style: italic; }
                        .print-footer { position: fixed; bottom: 20px; left: 0; width: 100%; text-align: center; }
                        .firma { display: inline-block; padding-top: 10px; border-top: 1px solid #000; width:240px; }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <h2>Detalles de expediente médico</h2>
                        <div class="label">ID de consulta:</div>
                        <div>${appointment.appointment_id}
                        </div>
                        <div class="label">Fecha de consulta:</div>
                        <div>
                            ${new Date(appointment.created_at).toLocaleString(
                                'es-ES',
                                {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                },
                            )}
                        </div>
                    </div>

                    <div class="section">
                        <div class="section-title">Información Básica</div>
                        <div class="grid-container">
                            <div class="label">Paciente ID:</div>
                            <div>${appointment.patient_id.split('/')[1]}</div>

                            <div class="label">Nombre del paciente:</div>
                            <div>${this.itemsPatient.nombre} ${
                this.itemsPatient.primerApellido
            } ${this.itemsPatient.segundoApellido}</div>
                            <div class="label">Fecha de nacimiento del paciente:</div>
                            <div>${
                                formattedBirthdate == 'Invalid Date'
                                    ? this.itemsPatient.birthdate
                                    : formattedBirthdate
                            }</div>

                            <div class="label">Médico:</div>
                            <div>
                                ${appointment.practitioner}
                            </div>

                            <div class="label">Estado del diagnóstico:</div>
                            <div class="${
                                appointment.status === 'active'
                                    ? 'status-active'
                                    : 'status-inactive'
                            }">
                                ${
                                    appointment.status === 'active'
                                        ? 'Activa'
                                        : 'Inactiva'
                                }
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="section-title">Diagnóstico</div>
                        <div class="grid-container">
                            <div class="label">Enfermedades:</div>
                            <div class="multi-container">
                                ${
                                    appointment.appointmentDiseases &&
                                    appointment.appointmentDiseases.length > 0
                                        ? appointment.appointmentDiseases
                                              .map(
                                                  (disease) => `
                                        <div>
                                            ${disease.diseaseName}
                                            (ID: ${disease.diseaseId})<br>
                                        </div>
                                    `,
                                              )
                                              .join('')
                                        : '<div class="not-available">No se registraron diagnósticos</div>'
                                }
                            </div>
                        </div>
                    </div>
                    <div class="section">
                        <div class="section-title">Notas Clínicas</div>
                        <p>${
                            appointment.note ||
                            '<span class="not-available">No hay notas registradas</span>'
                        }</p>
                    </div>
                    <footer class="print-footer">
                        <div class="firma">${appointment.practitioner}</div>
                    </footer>
                </body>
                </html>
                `);

            print_window.print();
            setTimeout(() => {
                print_window.close();
            }, 500);
        },
        disabledDiagnostic(event) {
            const timestampEvent = new Date(event.created_at).getTime();
            const timestampEnd = new Date().getTime() - 21600000;
            return event.status == 'active' && timestampEvent < timestampEnd;
        },
        crearReceta(event) {
            sessionStorage.setItem('tempAppointmentId', event.appointment_id);
            this.$router.push({
                name: 'CrearReceta',
                params: { id: this.$route.params.id },
            });
        },
        editarDiagnostico(event) {
            // Guardar la información del diagnóstico en sessionStorage
            try {
                sessionStorage.setItem('tempEditDiagnostic', event._key);
                const diagnosticData = {
                    note: event.note,
                    appointmentDiseases: event.appointmentDiseases,
                    patient_weight: event.patient_weight,
                    patient_height: event.patient_height,
                    status: event.status
                };
                sessionStorage.setItem('diagnosisData', JSON.stringify(diagnosticData));
            } catch (error) {
                console.error('Error al guardar en sessionStorage:', error);
            }

            // Asegurarnos de que tenemos el id del paciente y el key del diagnóstico
            const patientId = this.patientId;
            const diagnosisId = event._key;

            try {
                this.$router.push({
                    name: 'CrearDiagnostico',
                    params: {
                        id: patientId
                    },
                    query: {
                        diagnosisId: diagnosisId
                    }
                }).then(() => {
                    console.log('Navegación exitosa');
                }).catch(err => {
                    console.error('Error en la navegación:', err);
                });
            } catch (error) {
                console.error('Error al intentar navegar:', error);
            }
        },
    },
};
</script>

<style scoped>
.timeline-container {
    margin: -30px auto 0px auto;
    padding: 0px 20px;
}

.timeline {
    position: relative;
    padding: 15px 0;
}

.timeline-line {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: var(--celeste-electrico);
    transform: translateX(-50%);
    z-index: 0;
}

.day-group {
    position: relative;
    margin-bottom: 40px;
}

.day-header {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.day-title {
    background: var(--celeste-electrico);
    font-family: var(--font-body);
    color: white;
    padding: 8px 20px;
    border-radius: 5px;
    font-weight: 600;
    font-size: 1.1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
}

.day-subtitle {
    font-family: 'Trebuchet MS';
    color: var(--celeste-electrico);
    padding: 8px 20px;
    font-weight: 600;
    font-size: 24px;
    z-index: 10;
}

.events-container {
    display: flex;
    flex-direction: column;
    margin: 10px 0px;
}

.event-pair {
    display: flex;
    justify-content: space-between;
    position: relative;
}

/* card container */
.event-timeline {
    width: 100%;
    height: auto;
    align-self: center;
    position: relative;
    margin: 10px 0px;
    border: 1px solid var(--gris-urbano);
    border-radius: 10px;
}

.card-title-container {
    align-self: center;
    padding: 0px 10px !important;
    border-bottom: 1px solid var(--gris-urbano);
}

.card-title {
    color: var(--celeste-electrico);
    font-family: var(--font-body);
    font-weight: bold;
    font-size: 16px;
}

.card-text {
    font-family: var(--font-body);
    font-size: 16px;
    align-self: center;
}

.card-body {
    padding-top: 10px;
}

.tags-container {
    max-height: 200px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tag-custom {
    background-color: var(--celeste-electrico);
    padding: 5px;
    border-radius: 8px;
    font-family: var(--font-body);
    font-size: 16px;
    color: white;
}

.tag-disease {
    background-color: #cccccc;
    padding: 5px;
    border-radius: 8px;
    font-family: var(--font-body);
    font-size: 16px;
}

.pair-connector {
    position: absolute;
    display: flex;
    flex-direction: column;
    z-index: 1;
}

.icon-equal {
    font-size: 60px;
    color: var(--celeste-electrico);
    margin: 0px !important;
    padding-top: 5px !important;
    line-height: 40px;
    background-color: #ffffff;
}

.footer-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* border-top: 1px solid var(--gris-urbano); */
    padding-top: 10px;
}

/* .date {
    font-style: italic;
    letter-spacing: 0.5px;
    margin-right: 20px;
} */

.medication-list {
    margin: 0;
    padding: 0;
    width: 100%; /* Asegura el ancho completo */
}

.medication-item {
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    margin-bottom: 4px;
    margin-left: 12px;
    font-family: 'Trebuchet MS';
    list-style-type: none;
}

.medication-item::before {
    content: '*';
    position: absolute;
    left: 0;
    margin-left: 14px;
}

/* Estilo para notas canceladas */
.cancelled-note {
    background-color: #f0f0f0;
    opacity: 0.8;
}

.cancelled-note * {
    color: #666 !important;
    text-decoration: line-through;
}

.cancelled-note .info-status {
    background-color: #e0e0e0 !important;
    color: #616161 !important;
}

.operation-wrapper {
    display: flex;
    align-items: center;
}

.custom-button {
    background-color: #e7f8fe;
    color: var(--color-principal);
    border: 1px solid var(--color-principal);
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.custom-button:hover:not(:disabled) {
    background-color: #c5effe;
    border-color: #5abeea;
}

.custom-button:disabled {
    background-color: #f5f5f5;
    color: #9e9e9e;
    border: 1px solid #9e9e9e;
    cursor: not-allowed;
    opacity: 0.7;
}

.operation-icon {
    color: var(--color-principal);
    cursor: pointer;
}

.btn-active {
    border: 1px solid #ff0000;
    background-color: #fdecec;
    padding: 5px;
    color: #ff0000;
}
.btn-disabled {
    border: 1px solid #b0b0b0;
    background-color: #e0e0e0;
    color: #6c757d;
    padding: 5px;
    cursor: not-allowed;
}

.center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.trebuchet {
    font-family: 'Trebuchet MS';
}

.text-center {
    margin-top: 20px;
}
</style>
